function initMegaMenu() {
    const hamburgerIcon = document.querySelector(".hamburger");
    const megaMenu = document.querySelector(".mega-menu");
    const closeMenuIcon = document.querySelector(".close-hamburger");
    hamburgerIcon.addEventListener("click", () => {
        megaMenu.classList.add('open');
    });
    closeMenuIcon.addEventListener("click", () => {
        megaMenu.classList.remove('open');
    });
}
